import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import LogoMark from '../assets/Logomark.png'
import SideMenu from '../layouts/SideMenu'
import '../layouts/stylesheets/loader-style.css'
import { FORGOT_PASSWORD_QUERY } from '../services/GraphQLQueries'
import ValidateEmail from '../components/EmailValidation'

export default function ResetPassword() {
  const [forgotPasswordMutation, { loading }] = useMutation(
    FORGOT_PASSWORD_QUERY
  )
  const [forgotPasswordForm, setForgotPasswordForm] = useState({
    email: '',
  })
  const navigate = useNavigate()

  const handleChange = (event) => {
    setForgotPasswordForm({
      ...forgotPasswordForm,
      [event.target.id]: event.target.value,
    })
  }
  const [formErrors, setFormErrors] = useState({ errors: {} })

  const resetPassword = async (e) => {
    e.preventDefault();
    let errors = {};
    let proceed = true;

    // Validate the email field
    if (
      forgotPasswordForm.email.length < 3 ||
      !ValidateEmail(forgotPasswordForm.email)
    ) {
      errors.email = 'Please enter a valid email address.';
      proceed = false;
    }

    if (!proceed) {
      setFormErrors({ ...formErrors, errors });
      return;
    }

    // Trigger the GraphQL forgotPassword mutation
    forgotPasswordMutation({
      variables: { email: forgotPasswordForm.email },
      onCompleted: (data) => {
        const result = data?.forgotPassword;
        if (result?.success) {
          alert('If an account with that email exists, a reset link has been sent.');
          navigate('/signin');
        } else {
          setFormErrors({
            errors: { ...formErrors, email: 'Unable to send reset email. Please try again.' },
          });
        }
      },
      onError: (error) => {
        console.error('Forgot password failed:', error);
        setFormErrors({
          errors: { ...formErrors, email: 'Something went wrong. Please try again later.' },
        });
      },
    });
  };

  return (
    <div className="flex justify-center items-center" aria-live="polite">
      <SideMenu></SideMenu>
      <div className="w-full flex justify-center">
        {loading ? (
          <>
            <div className="loader-wrapper">
              <div className="flex justify-center items-center">
                <div className="grid gap-10">
                  <div className="loader"></div>
                  <div className="text-center">Resetting...</div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="grid gap-6 md:w-96 w-72 mb-36">
            <div className="flex justify-center">
              <img
                className="w-[46px] h-[46px]"
                src={LogoMark}
                alt="LogoMark"
              />
            </div>
            <div className="flex justify-center">
              <h3 className="w-full text-3xl font-semibold text-gray-900 text-center">
                Reset Your Password
              </h3>
            </div>
            <div>
              <p className="text-gray-700 text-sm font-medium mb-1">Email*</p>
              <input
                type="email"
                id="email"
                className=" text-black border border-gray-300 placeholder-gray-500 rounded-md block w-full p-2"
                placeholder="Enter your email"
                required
                value={forgotPasswordForm.email}
                onChange={handleChange}
              />
              {formErrors.errors.email ? (
                <p
                  style={{
                    color: '#f44',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {formErrors.errors.email}
                </p>
              ) : (
                ''
              )}
            </div>
            <input
              type="button"
              id="continue"
              onClick={resetPassword}
              className="bg-onTrack-light-purple font-semibold text-white text-center placeholder-white rounded-md block w-full p-2"
              placeholder="Send Mail"
              value="Send Mail"
            />
          </div>
        )}
      </div>
    </div>
  )
}
